import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Button } from 'reactstrap';
import AuthContext from '../../contexts/Auth';
import { Notificacao } from '../../entities/Security';
import api from '../../services/api';
import Situacoes from './Situacoes';
import NotificacaoModal from './NotificacaoModal'

interface INotificacoesLista {
  direction?: "up" | "down" | "left" | "right";
  iconColor?: string;
}

const NotificacoesLista: React.FC<INotificacoesLista> = ({ iconColor = "white" }) => {

  const history = useHistory();
  const { hasRole } = useContext(AuthContext)
  const [totalNotificacoesNaoLidas, setTotalNotificacoesNaoLidas] = useState(0)
  const [notificacoes, setNotificacoes] = useState<Array<Notificacao>>([])

  const [situacao, setSituacao] = useState('nao_lidas')
  const [showNotificacaoModal, setShowNotificacaoModal] = useState(false)
  const [notificacao, setNotificacao] = useState<Notificacao>()
  const [isOpen, setIsOpen] = useState(false)
  const [panelBottom, setPanelBottom] = useState(0)
  const [panelLeft, setPanelLeft] = useState(0)
  const bellRef = useRef<HTMLButtonElement>(null)

  const openPanel = () => {
    const sidenav = document.querySelector('.sidenav');
    const sidenavRight = sidenav ? sidenav.getBoundingClientRect().right + 8 : 258;
    const bellRect = bellRef.current?.getBoundingClientRect();
    const bottom = bellRect ? window.innerHeight - bellRect.bottom : 40;
    const isMobile = window.innerWidth <= 768;
    setPanelLeft(isMobile ? 8 : sidenavRight);
    setPanelBottom(bottom);
    setIsOpen(true);
  };

  const closePanel = () => setIsOpen(false);

  useEffect(() => {
    getNotificacoes();
  }, [situacao])


  function handleOnConferir() {
    setShowNotificacaoModal(false);
    //@ts-ignore
    handleSelectNotificacao(notificacao);
    marcarComoLida();
  }

  function handleOnMarcarLida() {
    marcarComoLida();
  }

  function goToNotificacoes() {
    closePanel();
    history.push(`/admin/notificacoes`)
  }

  function handleSelectNotificacao(notificacao: Notificacao) {
    var acao_clique_url = notificacao.acao_clique_url;

    if (acao_clique_url?.includes('http://localhost:3000')) {
      acao_clique_url = acao_clique_url.replace('http://localhost:3000', '');
    } else {
      if (acao_clique_url?.includes('http://playnee.com.br') || acao_clique_url?.includes('https://playnee.com.br')
        || acao_clique_url?.includes('http://app.playnee.com.br') || acao_clique_url?.includes('https://app.playnee.com.br')
        || acao_clique_url?.includes('http://app.playnee.com') || acao_clique_url?.includes('https://app.playnee.com')
        || acao_clique_url?.includes('http://hml.playnee.com.br') || acao_clique_url?.includes('https://hml.playnee.com.br')) {
        acao_clique_url = acao_clique_url.replace('http://playnee.com.br', '');
        acao_clique_url = acao_clique_url.replace('https://playnee.com.br', '');
        acao_clique_url = acao_clique_url.replace('http://app.playnee.com.br', '');
        acao_clique_url = acao_clique_url.replace('https://app.playnee.com.br', '');
        acao_clique_url = acao_clique_url.replace('http://app.playnee.com', '');
        acao_clique_url = acao_clique_url.replace('https://app.playnee.com', '');
        acao_clique_url = acao_clique_url.replace('http://hml.playnee.com.br', '');
        acao_clique_url = acao_clique_url.replace('https://hml.playnee.com.br', '');
      }
    }

    if (acao_clique_url?.includes('http://') || acao_clique_url?.includes('https://')) {
      window.open(acao_clique_url, '_blank');
    } else {
      if (acao_clique_url) {
        if (!acao_clique_url?.includes('/oportunidades/') && acao_clique_url?.includes('/oportunidades')) {
          if (hasRole('comercial_restritivo')) {
            acao_clique_url = acao_clique_url.replace('/oportunidades', '/oportunidades-readonly')
          }
        }
        history.push(acao_clique_url)
      }
    }
  }

  async function getNotificacoes() {
    try {
      var paramSituacao = situacao ? `?situacao=${situacao}` : ''
      var url = '/security/notificacoes/getByUsuarioLogado' + paramSituacao
      const response = await api.get(url);
      setNotificacoes(response.data.notificacoes);
      setTotalNotificacoesNaoLidas(response.data.totalNaoLidas)
    } catch (error) {
    }
  }

  async function marcarComoLida() {
    try {
      await api.put(`/security/notificacoes/marcarComoLida/${notificacao?.id}`);
      getNotificacoes();
      setShowNotificacaoModal(false);
    } catch (error) {
    }
  }

  return <>
    <NotificacaoModal
      notificacao={notificacao}
      show={showNotificacaoModal}
      onHidden={() => setShowNotificacaoModal(false)}
      onConferir={handleOnConferir}
      onMarcarComoLida={handleOnMarcarLida}
    />

    {/* Backdrop para fechar ao clicar fora */}
    {isOpen && (
      <div
        style={{ position: 'fixed', inset: 0, zIndex: 1049 }}
        onClick={closePanel}
      />
    )}

    {/* Botão do sino */}
    <button
      ref={bellRef}
      onClick={isOpen ? closePanel : openPanel}
      style={{
        background: 'transparent',
        border: 'none',
        color: iconColor,
        padding: 0,
        position: 'relative',
        cursor: 'pointer',
        lineHeight: 1,
      }}
    >
      <i className="ni ni-bell-55" style={{ fontSize: '1.25rem' }}></i>
      <span style={{
        display: totalNotificacoesNaoLidas > 0 ? 'block' : 'none',
        background: 'rgb(255 0 0 / 90%)',
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        position: 'absolute',
        top: '-3px',
        right: '-5px',
        paddingTop: '1px',
        fontFamily: 'Inter, sans-serif',
        fontSize: '8px',
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'white',
        zIndex: 1,
      }}>{totalNotificacoesNaoLidas}</span>
    </button>

    {/* Painel de notificações fixo ao lado do sidebar */}
    {isOpen && (
      <div
        style={{
          position: 'fixed',
          left: panelLeft,
          bottom: panelBottom,
          zIndex: 1050,
          background: '#ffffff',
          borderRadius: '8px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          width: '320px',
          maxHeight: 'calc(100vh - 80px)',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header com label e filtros */}
        <div style={{
          padding: '12px 16px 8px',
          borderBottom: '1px solid #e9ecef',
          position: 'sticky',
          top: 0,
          background: '#fff',
          zIndex: 1,
        }}>
          <div style={{ fontSize: '12px', fontWeight: 600, color: '#8898aa', textTransform: 'uppercase', marginBottom: '8px' }}>
            {(!notificacoes || notificacoes.length === 0)
              ? 'Nenhuma notificação'
              : situacao === 'nao_lidas'
                ? `Você tem ${totalNotificacoesNaoLidas > 1 ? `${totalNotificacoesNaoLidas} não lidas` : '1 não lida'}`
                : situacao === 'lidas'
                  ? 'Notificações lidas'
                  : 'Últimas notificações'
            }
          </div>
          <Situacoes value={situacao} onChange={setSituacao} />
        </div>

        {/* Lista de notificações */}
        <div>
          {notificacoes.map((notif, key) => {
            if (key >= 10) return null;
            return (
              <div
                key={notif.id}
                onClick={() => {
                  setNotificacao(notif);
                  setShowNotificacaoModal(true);
                }}
                style={{
                  padding: '10px 16px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f6f9fc',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  color: 'black',
                }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = '#f6f9fc' }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent' }}
              >
                <div style={{ width: '24px', textAlign: 'center', color: !notif.readed_at ? 'red' : '#adb5bd', flexShrink: 0 }}>
                  <i className={notif.icon_font}></i>
                </div>
                <span style={{ fontSize: '13px' }}>{notif.titulo}</span>
              </div>
            );
          })}
        </div>

        {/* Rodapé */}
        <div style={{ padding: '8px', borderTop: '1px solid #e9ecef', textAlign: 'center' }}>
          <Button
            style={{ paddingTop: 0, paddingBottom: 0, color: '#0847d6', fontSize: '13px' }}
            color="link"
            type="button"
            onClick={goToNotificacoes}
          >
            Ver Mais
          </Button>
        </div>
      </div>
    )}
  </>
}

export default NotificacoesLista;
